<template>
    <v-app pb-3>
        <v-content>
            <v-form ref="form">
                <v-container style="max-width: 1800px; padding-top: 100px">
                    <div class="breadcrumb-new">
                        <a href="/dashboard">Личный кабинет</a>
                        <span>›</span>
                        <span v-if="showAgents">Все пользователи</span>
                        <span v-if="!showAgents">Сотрудники</span>
                    </div>
                    <div class="top-row">
                        <h1 class="page-title">Все <span>пользователи</span></h1>
                        <div class="action-buttons">
                            <button
                                v-if="showAgents"
                                class="btn btn-primary"
                                @click.prevent="openLink('/register/agent', '_blank')"
                            >
                                <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
                                </svg>
                                Создать пользователя
                            </button>

                            <button
                                class="btn btn-primary"
                                @click.prevent="openLink('/register/operator', '_blank')"
                            >
                                <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/>
                                </svg>
                                Создать сотрудника
                            </button>
                        </div>
                    </div>

                    <div class="control-bar">
                        <div class="search-cluster">
                            <div class="text-search">
                                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                                    <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                                </svg>
                                <input
                                    type="text"
                                    placeholder="Поиск по ФИО, телефону, e-mail..."
                                    v-model="filters.search"
                                    @keydown.enter.prevent="newSearch"
                                >
                            </div>
                        </div>

                        <div class="btn-cluster">
                            <button class="btn btn-outline btn-search-width" @click.prevent="newSearch">
                                <svg width="17" height="17" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
                                    <circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/>
                                </svg>
                                Поиск
                            </button>
                        </div>
                    </div>
                </v-container>
                <v-container style="max-width: 1800px;">
                    <div class="policy-list-table mb-3">
                        <div class="filters-block">
                            <div class="filters-block__header" @click="showFilters">
                                <h3 class="py-0">Фильтры</h3>
                                <v-icon class="material-symbols-outlined arrow-up-down" :class='{ "rotate": panel.length }'>
                                    expand_more
                                </v-icon>
                            </div>

                            <v-expansion-panel v-model="panel" expand>
                                <v-expansion-panel-content>
                                    <div class="filters-block__body">
                                        <v-layout py-0 row wrap class="filters">
                                            <v-flex xs12 sm6 py0 v-if="showAgents">
                                                <v-autocomplete
                                                    v-model="filters.agent"
                                                    ref="filterAgent"
                                                    label="Пользователь"
                                                    :items="agentsList"
                                                    :loading="isLoadingAgentsFilter"
                                                    item-value="id"
                                                    item-text="name"
                                                    placeholder="Введите ФИО или еmаil"
                                                    hide-no-data
                                                    multiple
                                                    chips
                                                    deletable-chips
                                                    :allow-overflow=false
                                                ></v-autocomplete>
                                            </v-flex>
                                            <v-flex xs12 sm6 py0 v-if="showCurators">
                                                <v-autocomplete
                                                    v-model="filters.curator"
                                                    ref="filterCurator"
                                                    label="Куратор"
                                                    :items="curatorsList"
                                                    :loading="isLoadingCuratorsFilter"
                                                    item-value="id"
                                                    item-text="name"
                                                    placeholder="Введите ФИО или еmаil"
                                                    hide-no-data
                                                    multiple
                                                    chips
                                                    deletable-chips
                                                    :allow-overflow=false
                                                ></v-autocomplete>
                                            </v-flex>
                                            <v-flex xs6 sm3 py0>
                                                <v-autocomplete
                                                    v-model="filters.region"
                                                    ref="filterRegion"
                                                    :items="regionsList"
                                                    item-value="id"
                                                    item-text="name"
                                                    label="Регион"
                                                    hide-no-data
                                                ></v-autocomplete>
                                            </v-flex>
                                            <v-flex xs6 sm3 py0>
                                                <v-select
                                                    v-model="filters.role"
                                                    ref="filterRole"
                                                    :items="rolesList"
                                                    item-value="id"
                                                    item-text="name"
                                                    label="Роль"
                                                ></v-select>
                                            </v-flex>
                                            <v-flex xs6 sm3 py0>
                                                <v-select
                                                    v-model="filters.status"
                                                    ref="filterStatus"
                                                    :items="statusesList"
                                                    item-value="id"
                                                    item-text="name"
                                                    label="Статус"
                                                ></v-select>
                                            </v-flex>
                                            <v-flex xs6 sm3 py0>
                                                <v-select
                                                    v-model="filters.type"
                                                    ref="filterType"
                                                    :items="typesList"
                                                    item-value="id"
                                                    item-text="name"
                                                    label="Тип пользователя"
                                                ></v-select>
                                            </v-flex>
                                            <v-flex xs6 sm3 py0>
                                                <v-select
                                                    v-model="filters.channel"
                                                    ref="filterType"
                                                    :items="advStatusesList"
                                                    item-value="id"
                                                    item-text="name"
                                                    label="Канал привлечения"
                                                ></v-select>
                                            </v-flex>
                                            <v-flex xs6 sm3 py0>
                                                <osago-date
                                                    label="Период полисов, от"
                                                    v-model="filters.period_from"
                                                    :max="filters.period_to"
                                                    :yearStarting="false"
                                                    :isRequired="false"
                                                />
                                            </v-flex>
                                            <v-flex xs6 sm3 py0>
                                                <osago-date
                                                    label="Период полисов, до"
                                                    v-model="filters.period_to"
                                                    :min="filters.period_from"
                                                    :yearStarting="false"
                                                    :isRequired="false"
                                                />
                                            </v-flex>
                                        </v-layout>

                                        <v-layout class="filters-actions">
                                            <a @click="cleanFilters" class="link">Очистить фильтры</a>
                                            <div class="download-excel-button">
                                                <v-tooltip bottom>
                                                    <template #activator="{ on, attrs }">
                                                        <v-btn
                                                            flat
                                                            icon
                                                            color="#00ba57"
                                                            v-bind="attrs"
                                                            v-on="on"
                                                            @click="downloadAgentsExport"
                                                        >
                                                            <v-icon medium>arrow_circle_down</v-icon>
                                                        </v-btn>
                                                    </template>
                                                    <span>Выгрузить результат</span>
                                                </v-tooltip>
                                            </div>
                                        </v-layout>
                                    </div>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </div>
                    </div>

                    <v-layout v-if="showReport" row wrap class="report-layout mb-3">
                        <v-flex xs6 sm4 md2 py-0>
                            <osago-date
                                label="Дата отчета, от"
                                v-model="report.from"
                                :max="report.to"
                                :yearStarting="false"
                            />
                        </v-flex>
                        <v-flex xs6 sm4 md2 py-0>
                            <osago-date
                                label="Дата отчета, до"
                                v-model="report.to"
                                :min="report.from"
                                :yearStarting="false"
                            />
                        </v-flex>
                        <v-flex xs12 sm4 md3 class="btn-report-wrapper">
                            <button
                                class="btn btn-primary btn-report-width"
                                @click.prevent="curatorsReport"
                                :disabled="report.loading"
                            >
                                <svg
                                    v-if="!report.loading"
                                    viewBox="0 0 24 24" width="18" height="18" fill="currentColor" stroke="currentColor" xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                    <g id="SVGRepo_iconCarrier">
                                        <path d="M12.5535 16.5061C12.4114 16.6615 12.2106 16.75 12 16.75C11.7894 16.75 11.5886 16.6615 11.4465 16.5061L7.44648 12.1311C7.16698 11.8254 7.18822 11.351 7.49392 11.0715C7.79963 10.792 8.27402 10.8132 8.55352 11.1189L11.25 14.0682V3C11.25 2.58579 11.5858 2.25 12 2.25C12.4142 2.25 12.75 2.58579 12.75 3V14.0682L15.4465 11.1189C15.726 10.8132 16.2004 10.792 16.5061 11.0715C16.8118 11.351 16.833 11.8254 16.5535 12.1311L12.5535 16.5061Z"></path>
                                        <path d="M3.75 15C3.75 14.5858 3.41422 14.25 3 14.25C2.58579 14.25 2.25 14.5858 2.25 15V15.0549C2.24998 16.4225 2.24996 17.5248 2.36652 18.3918C2.48754 19.2919 2.74643 20.0497 3.34835 20.6516C3.95027 21.2536 4.70814 21.5125 5.60825 21.6335C6.47522 21.75 7.57754 21.75 8.94513 21.75H15.0549C16.4225 21.75 17.5248 21.75 18.3918 21.6335C19.2919 21.5125 20.0497 21.2536 20.6517 20.6516C21.2536 20.0497 21.5125 19.2919 21.6335 18.3918C21.75 17.5248 21.75 16.4225 21.75 15.0549V15C21.75 14.5858 21.4142 14.25 21 14.25C20.5858 14.25 20.25 14.5858 20.25 15C20.25 16.4354 20.2484 17.4365 20.1469 18.1919C20.0482 18.9257 19.8678 19.3142 19.591 19.591C19.3142 19.8678 18.9257 20.0482 18.1919 20.1469C17.4365 20.2484 16.4354 20.25 15 20.25H9C7.56459 20.25 6.56347 20.2484 5.80812 20.1469C5.07435 20.0482 4.68577 19.8678 4.40901 19.591C4.13225 19.3142 3.9518 18.9257 3.85315 18.1919C3.75159 17.4365 3.75 16.4354 3.75 15Z"></path>
                                </g></svg>
                                <span v-if="!report.loading">
                                    Отчет специальной формы
                                </span>
                                <span
                                    v-if="report.loading"
                                    class="spinner"
                                ></span>
                            </button>
                        </v-flex>
                    </v-layout>

                    <v-layout py-0 mb-3 row wrap v-if="showSegmentation" v-show="selected.length">
                        <v-flex xs12 md4>
                            Выделено сотрудников: <span style="color: #00BA57;">{{ selected.length }}</span><br>
                            <v-select
                                :items="this.segmentationsList"
                                v-model="setSegmentation"
                                item-value="id"
                                item-text="name"
                                label="Установить шаблон сегментации"
                            >
                            </v-select>
                        </v-flex>
                        <v-flex xs12 md6 mt-auto>
<!--                            <v-btn class="seg-template-btn"
                                @click="setSegTemplate"
                            >Установить шаблон</v-btn>-->
                            <button
                                class="btn btn-primary btn-set-template"
                                @click.prevent="setSegTemplate"
                            >
                                <svg viewBox="0 0 24 24" width="18" height="18" fill="currentColor" stroke="currentColor" xmlns="http://www.w3.org/2000/svg">
                                    <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                                    <g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g>
                                    <g id="SVGRepo_iconCarrier">
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M19.7071 6.29289C20.0976 6.68342 20.0976 7.31658 19.7071 7.70711L10.4142 17C9.63316 17.7811 8.36683 17.781 7.58579 17L3.29289 12.7071C2.90237 12.3166 2.90237 11.6834 3.29289 11.2929C3.68342 10.9024 4.31658 10.9024 4.70711 11.2929L9 15.5858L18.2929 6.29289C18.6834 5.90237 19.3166 5.90237 19.7071 6.29289Z"></path>
                                    </g>
                                </svg>
                                <span>Установить шаблон</span>
                            </button>
                        </v-flex>
                    </v-layout>

                    <div class="policy-list-table">
                        <div class="policy-list-table__body">
                            <v-data-table
                                py-5
                                ref="agentsListTable"
                                v-model="selected"
                                :headers="headers"
                                :items="rows"
                                :pagination.sync="pagination"
                                :total-items="totalRows"
                                :loading="loading"
                                item-key="user_id"
                                :rows-per-page-items="[10,25,50]"
                                rows-per-page-text="Показывать по"
                                select-all
                                multi-sort
                                no-data-text="Нет данных"
                                no-results-text="Ничего не найдено"
                            >
                                <template v-slot:no-results>
                                    <v-layout py-5>
                                        <p>Ничего не найдено. <a @click="cleanFilters">Очистить фильтры</a></p>
                                    </v-layout>
                                </template>
                                <template v-slot:headers="props">
                                    <tr>
                                        <th>
                                            <v-checkbox
                                                :input-value="props.all"
                                                :indeterminate="props.indeterminate"
                                                primary
                                                hide-details
                                                @click.stop="toggleAll"
                                            ></v-checkbox>
                                        </th>
                                        <th
                                            v-for="header in props.headers"
                                            :key="header.text"
                                            :class="['column text-xs-left',
                                                  pagination.descending ? 'desc' : 'asc',
                                                  header.sortable ? 'sortable' : '',
                                                  header.value === pagination.sortBy ? 'active' : '',
                                                  header.class ? header.class : ''
                                                ]"
                                            @click="header.sortable && changeSort(header.value)"
                                        >
                                            {{ header.text }}
                                            <v-icon v-if="header.sortable" small>arrow_upward</v-icon>
                                        </th>
                                    </tr>
                                </template>
                                <template v-slot:items="props">
                                    <tr
                                        :active="props.selected"
                                        class="table-row"
                                        :class="[!props.item['read_by_curator'] && props.item['user_parent_id'] == selfId ? 'not-read' : '' ]"
                                        :id="'listElement-' + props.item['agent_id']"
                                    >
                                        <td>
                                            <v-checkbox
                                                v-model="props.selected"
                                                primary
                                                hide-details
                                            ></v-checkbox>
                                        </td>
                                        <td class="py-4">
                                            <a v-if="props.item['user_id'] !== props.item['agent_id']" :href="'/agent/' + props.item['user_id']" target="_blank">
                                                <span>{{ formatName(props.item['user_name']) }}</span>
                                            </a>
                                            <a v-if="props.item['user_id'] === props.item['agent_id']" @click="clickAgentLink(props.item)">
                                                <span>{{ formatName(props.item['user_name']) }}</span>
                                            </a>
                                        </td>
                                        <td class="py-4" v-if="showSegmentation">
                                            <span>{{ props.item['user_segmentation_template_name'] }}</span>
                                        </td>
                                        <td class="py-4" v-if="showAgents">
                                            <a @click="clickAgentLink(props.item)">
                                                <span>{{ props.item['agent_name'] }}</span>
                                            </a>
                                        </td>
                                        <td class="py-4" v-if="showCurators">
                                            <a :href="'/agent/' + props.item['curator_id']" v-if="props.item['curator_id']" target="_blank">
                                                <span>{{ props.item['curator_name'] }}</span>
                                            </a>
                                            <span v-if="!props.item['curator_id']">{{ props.item['curator_name'] }}</span>
                                        </td>
                                        <td>{{ props.item['user_email'] }}</td>
                                        <td>{{ props.item['user_phone'] }}</td>
                                        <td>{{ props.item['user_city'] }}</td>
                                        <td>{{ props.item['user_role'] }}</td>
                                        <td>{{ props.item['user_status_text'] }}</td>
                                        <td class="text-md-center no-wrap">{{ props.item['orders_commission_formatted'] }}</td>
                                        <td>{{ props.item['user_legal_type_text'] }}</td>
                                        <td class="text-md-center">{{ props.item['last_login_formatted'] }}</td>
                                        <td class="text-md-center">{{ props.item['orders_count'] }}</td>
                                        <td class="text-md-center no-wrap">{{ props.item['orders_sum_formatted'] }}</td>
                                        <td class="text-md-center no-wrap">{{ props.item['bank_card_number'] ? props.item['bank_card_number'] : '—' }}</td>
                                        <td class="text-md-center no-wrap">{{ props.item['bank_full_name'] ? props.item['bank_full_name'] : '—' }}</td>
                                        <td class="text-md-center no-wrap">{{ props.item['bank_issuing_bank'] ? props.item['bank_issuing_bank'] : '—' }}</td>
                                        <td class="text-xs-right px-0 table-actions" v-if="selfId!==props.item['user_id']">
                                            <v-menu>
                                                <template v-slot:activator="{ on }">
                                                    <v-btn icon v-on="on">
                                                        <v-icon>more_vert</v-icon>
                                                    </v-btn>
                                                </template>
                                                <v-list>
                                                    <v-list-tile @click="ban(props.item)" v-if="props.item['user_status_text']!=='Заблокирован'">
                                                        <v-list-tile-title>Заблокировать</v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile @click="ban(props.item)" v-if="props.item['user_status_text']==='Заблокирован'">
                                                        <v-list-tile-title>Разблокировать</v-list-tile-title>
                                                    </v-list-tile>
                                                    <v-list-tile @click="del(props.item)">
                                                        <v-list-tile-title>Удалить</v-list-tile-title>
                                                    </v-list-tile>
                                                </v-list>
                                            </v-menu>
                                        </td>
                                    </tr>
                                </template>
                                <template v-slot:pageText="props">
                                    {{ props.pageStart }} - {{ props.pageStop }} из {{ props.itemsLength }}
                                </template>
                            </v-data-table>
                        </div>
                    </div>
                </v-container>
            </v-form>
        </v-content>
    </v-app>

</template>

<script>
    import _ from 'lodash';

    export default {
        props: [
            'role',
            'self-id',
            'list',
            'total',
            'segmentations',
            'regions',
            'roles',
            'types',
            'statuses',
            'adv-statuses'
        ],

        data: () => ({
            filters: {
                search: '',
                role: null,
                status: null,
                type: null,
                curator: [],
                agent: [],
                region: null,
                channel: null,
                period_from: null,
                period_to: null
            },
            pagination: {
                descending: true,
                sortBy: 'created_at',
                page: 1,
                rowsPerPage: 10,
                totalItems: 0
            },
            setSegmentation: null,
            rolesList: [],
            statusesList: [],
            typesList: [],
            curatorsList: [],
            agentsList: [],
            segmentationsList: [],
            advStatusesList: [],

            headers: [],
            rows: [],
            totalRows: 0,
            selected: [],

            downloadFields: {},

            showCurators: false,
            showAgents: false,
            showSegmentation: false,
            showReport: false,

            regionsList: [],

            loading: false,
            init: false,

            isLoadingAgentsFilter: false,
            isLoadingCuratorsFilter: false,

            report: {
                from: null,
                to: null,
                loading: false
            },

            panel: [],
        }),

        watch: {
            // TODO: пока что такая костыльная обработка постранички, пока не придумаю что-то более элегантное
            'pagination.descending': {
                handler() {
                    this.paginationHandle();
                }
            },
            'pagination.sortBy': {
                handler() {
                    this.paginationHandle();
                }
            },
            'pagination.page': {
                handler() {
                    this.paginationHandle();
                }
            },
            'pagination.rowsPerPage': {
                handler() {
                    this.paginationHandle();
                }
            },
            filters: {
                handler() {
                    if (!this.init) {
                        return;
                    }
                    // TODO: для обработки доступности кнопки
                    //console.log('I\'ll be watching you', this.filters);
                },
                deep: true
            },
        },

        created: function () {
            if (this.role === 'admin') {
                this.showReport = this.showCurators = this.showAgents = this.showSegmentation = true;
                this.segmentationsList = JSON.parse(window.atob(this.segmentations));
            } else if (this.role === 'curator') {
                this.showReport = this.showAgents = true;
            }

            this.regionsList = JSON.parse(window.atob(this.regions));
            this.typesList = JSON.parse(window.atob(this.types));
            this.rolesList = JSON.parse(window.atob(this.roles));
            this.statusesList = JSON.parse(window.atob(this.statuses));
            this.advStatusesList = JSON.parse(window.atob(this.advStatuses));

            this.rows = JSON.parse(window.atob(this.list));
            this.totalRows = this.total;

            this.headers = [
                {text: 'Сотрудник', value: 'user_name', width: 170, sortable: true},
                {text: 'Сегментация', value: 'user_segmentation_template_name', width: 170},
                {text: 'Пользователь', value: 'agent_name', width: 170, sortable: true},
                {text: 'Куратор', value: 'curator_name', width: 170, sortable: true},
                {text: 'Почта', value: 'user_email', sortable: true},
                {text: 'Телефон', value: 'user_phone', sortable: true},
                {text: 'Город', value: 'user_city', sortable: true},
                {text: 'Роль', value: 'user_role_name'},
                {text: 'Статус', value: 'user_status_text', sortable: true},
                {text: 'Вознаграждение', value: 'user_orders_commission', sortable: false}, // тут нужны правки добавить чекбокс БП при котором будут отображаться опредеенные поля
                {text: 'Тип', value: 'user_type_name'},
                {text: 'Время последнего входа', value: 'user_last_login', sortable: true, class: 'wrappable'},
                {text: 'Оформленные полисы', value: 'orders_count', sortable: false, class: 'wrappable'},
                {text: 'Сумма по полисам', value: 'orders_sum_formatted', sortable: false, class: 'wrappable'},
                {text: 'Номер банковской карты', value: 'bank_card_number', sortable: false, class: 'wrappable'},
                {text: 'ФИО держателя', value: 'bank_full_name', sortable: false, class: 'wrappable'},
                {text: 'Банк эмитент', value: 'bank_issuing_bank', sortable: false, class: 'wrappable'},
                {text: '', value: '', class: 'px-0'},
            ];

            this.downloadFields = {
                '#': 'user_id',
                'Сотрудник': 'user_name',
                'Пользователь': 'agent_name',
                'Куратор': 'curator_name',
                'Почта': 'user_email',
                'Телефон': 'user_phone',
                'Город': 'user_city',
                'Роль': 'user_role',
                'Статус': 'user_status_text',
                'Вознаграждение': 'orders_commission',
                'Тип': 'user_legal_type_text',
                'Тип продаж': 'user_sales_type_text',
                'Пограничный переход': 'user_border_crossing_name',
                'Дата регистрации': 'created_at_formatted',
                'Время последнего входа': 'last_login_formatted',
                'Оформленные полисы': 'orders_count',
                'Сумма по полисам': 'orders_sum_formatted',
                'ID пользователя': {
                    field: 'user_id',
                    callback: (val) => {
                        let padded = String(val).padStart(5, '0');
                        return 'GP' + padded + 'CD';
                    }
                },
                'Номер банковской карты': 'bank_card_number',
                'ФИО держателя': 'bank_full_name',
                'Банк эмитент': 'bank_issuing_bank',
            };

            if (!this.showCurators) {
                _.remove(this.headers, {text: 'Куратор'});
                delete this.downloadFields['Куратор'];
            }

            if (!this.showAgents) {
                _.remove(this.headers, {text: 'Пользователь'});
                delete this.downloadFields['Пользователь'];
            }

            if (!this.showSegmentation) {
                _.remove(this.headers, {text: 'Сегментация'});
            }

            if (this.role !== 'admin' && this.role !== 'curator') {
                delete this.downloadFields['Тип продаж'];
                delete this.downloadFields['Пограничный переход'];
            }

            this.searchCuratorsFilter();
            this.searchAgentsFilter();

            this.init = true;
        },

        methods: {
            openLink(url, target) {
                window.open(url, target);
            },

            formatName(fullName) {
                if (!fullName) return ''

                const parts = fullName.split(' ')

                const lastName = parts[0] || ''
                const firstInitial = parts[1] ? parts[1][0] + '.' : ''
                const middleInitial = parts[2] ? parts[2][0] + '.' : ''

                return `${lastName} ${firstInitial} ${middleInitial}`.trim()
            },

            showFilters() {
                this.panel = this.panel.length ? [] : ['0'];
            },

            newSearch() {
                if (this.loading) {
                    return;
                }
                const data = {
                    s: this.pagination.sortBy,
                    desc: this.pagination.descending,
                    p: this.pagination.page,
                    i: this.pagination.rowsPerPage,
                    f: JSON.stringify(this.filters)
                };
                this.loading = true;
                axios.post('/agents-list', data)
                    .then(response => {
                        if (response.data && response.data.status === 'success') {
                            this.rows = JSON.parse(window.atob(response.data.list));
                            this.totalRows = response.data.total;
                        } else {
                            PNotify.error('Возникли ошибки при поиске');
                            console.log(response);
                        }
                        this.loading = false;
                    })
                    .catch(error => {
                        console.log(error);
                        PNotify.error('Возникли ошибки при поиске');
                        this.loading = false;
                    });
            },

            clickAgentLink(item) {
                let agentId = item['agent_id']
                let readByAdmin = item['read_by_admin']
                let readByCurator = item['read_by_curator']
                let element = document.getElementById('listElement-' + item['agent_id'])
                if (this.role === 'admin' && !readByAdmin) {
                    axios.post('/agent/' + agentId + '/read-by-admin')
                        .then(response => {
                            element.classList.remove('not-read')
                            window.open('/agent/' + agentId)
                        }).catch(error => {
                        console.log(error)
                        if (error.response.data.message) {
                            PNotify.alert(error.response.data.message)
                        }
                    })
                    return
                }
                if (this.role === 'curator' && !readByCurator) {
                    axios.post('/agent/' + agentId + '/read-by-curator')
                        .then(response => {
                            element.classList.remove('not-read')
                            window.open('/agent/' + agentId)
                        }).catch(error => {
                        console.log(error)
                        if (error.response.data.message) {
                            PNotify.alert(error.response.data.message)
                        }
                    })
                    return
                }
                window.open('/agent/' + agentId)
            },

            toggleAll() {
                if (this.selected.length) {
                    this.selected = [];
                } else {
                    this.selected = this.$refs.agentsListTable.filteredItems.slice();
                }
            },

            changeSort(column) {
                if (this.pagination.sortBy === column) {
                    this.pagination.descending = !this.pagination.descending;
                } else {
                    this.pagination.sortBy = column;
                    this.pagination.descending = false;
                }
            },

            cleanFilters() {
                this.filters.search = '';
                this.filters.role = null;
                this.filters.status = null;
                this.filters.type = null;
                this.filters.agent = [];
                this.filters.curator = [];
                this.filters.region = null;
                this.filters.period_from = null;
                this.filters.period_to = null;
                this.filters.channel = null;
                this.newSearch();
            },

            async downloadItems() {
                if (this.loading) {
                    return;
                }
                const data = {
                    s: this.pagination.sortBy,
                    desc: this.pagination.descending,
                    p: this.pagination.page,
                    i: -1,
                    f: JSON.stringify(this.filters)
                };
                this.loading = true;
                let result = [];
                await axios.post('/agents-list', data)
                    .then(response => {
                        if (response.data && response.data.status === 'success') {
                            result = JSON.parse(window.atob(response.data.list));
                        } else {
                            PNotify.error('Возникли ошибки при формировании файла');
                            console.log(response);
                        }
                        this.loading = false;
                    })
                    .catch(error => {
                        console.log(error);
                        PNotify.error('Возникли ошибки при формировании файла');
                        this.loading = false;
                    });

                return result;
            },

            ban(item) {
                axios.get('/agent/' + item['user_id'] + '/ban')
                    .then(response => {
                        item['user_status'] = response.data.status;
                        item['user_status_text'] = response.data.statusText;
                        Vue.set(this.rows, this.rows.findIndex((v) => v['user_id'] === item['user_id']), item);
                    }).catch(error => {
                    console.log(error);
                    if (error.response.data.message) {
                        PNotify.alert(error.response.data.message);
                    }
                });
            },

            del(item) {
                let that = this;
                PNotify.error({
                    text: 'Удалить пользователя?',
                    hide: false,
                    stack: {
                        'dir1': 'down',
                        'modal': true,
                        'firstpos1': 25
                    },
                    modules: {
                        Confirm: {
                            confirm: true,
                            buttons: [
                                {
                                    text: 'Удалить',
                                    primary: false,
                                    click: function () {
                                        axios.delete('/agent/' + item['user_id'])
                                            .then(response => {
                                                Vue.delete(that.rows, that.rows.findIndex((v) => v['user_id'] === item['user_id']));
                                                PNotify.removeAll();
                                            }).catch(error => {
                                            console.log(error);
                                            if (error.response.data.message) {
                                                PNotify.alert(error.response.data.message);
                                                PNotify.removeAll();
                                            }
                                        });
                                    },
                                },
                                {
                                    text: 'Отмена',
                                    primary: false,
                                    click: () => {
                                        PNotify.removeAll();
                                    },
                                }
                            ]
                        },
                        Buttons: {
                            closer: false,
                            sticker: false
                        },
                        History: {
                            history: false
                        }
                    }
                });
            },

            setSegTemplate() {
                const selectedUsers = this.selected.map(a => a['user_id']);

                if (selectedUsers.length === 0) {
                    PNotify.alert('Невозможно установить сегментацию для данных пользователей.');
                    return;
                }

                const formData = {
                    'selectedUsers': JSON.stringify(selectedUsers),
                    'templateId': this.setSegmentation === null ? null : this.setSegmentation
                }
                let that = this;
                axios.patch('/segmentation/set', formData)
                    .then(response => {
                        if (response.data.status === 'success') {
                            let segmentation = that.segmentationsList.find(a => a.id === response.data.templateId);
                            if (!segmentation) {
                                segmentation = {
                                    id: null,
                                    name: 'Не установлена'
                                };
                            }

                            let row = null;
                            for (let i = 0, rowsLen = this.rows.length; i < rowsLen; ++i) {
                                row = this.rows[i];
                                for (let j = 0, usrLen = selectedUsers.length; j < usrLen; ++j) {
                                    if (selectedUsers[j] === row['user_id']) {
                                        row['user_segmentation_template_id'] = segmentation.id;
                                        row['user_segmentation_template_name'] = segmentation.name;
                                        Vue.set(this.rows, this.rows[i], row);
                                        break;
                                    }
                                }
                            }
                            PNotify.success('Шаблон успешно установлен.');
                        }
                    })
                    .catch(error => {
                        PNotify.error('При установке шаблона возникла ошибка.');
                        console.log(error);
                    }
                );
            },

            curatorsReport() {
                this.report.loading = true;
                const data = {
                    from: this.report.from,
                    to: this.report.to,
                    curators: this.filters.curator
                };

                axios.post('/curators-report', data, {
                    responseType: 'blob',
                    headers: {
                        'Content-Type': 'application/json',
                        'Accept': 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
                    }
                }).then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const a = document.createElement('a');
                    const contentDisposition = response.headers["content-disposition"];
                    const match = contentDisposition.match(/filename\s*=\s*"(.+)"/i);
                    const filename = match[1];
                    a.href = url;
                    a.setAttribute('download', filename);
                    document.body.appendChild(a);
                    a.click();
                    a.remove();
                }).catch(error => {
                    console.log(error);
                    PNotify.error('Не удалось сформировать отчет.');
                }).finally(() => { this.report.loading = false; });
            },

            paginationHandle() {
                if (!this.init) {
                    return;
                }
                this.newSearch();
            },

            async searchAgentsFilter() {
                // Данные загружаются или уже получены
                if (this.isLoadingAgentsFilter || this.agentsList.length > 0) {
                    return;
                }

                this.isLoadingAgentsFilter = true;

                axios.get('/agents-list-local-get').then(response => {
                    this.agentsList = JSON.parse(window.atob(response.data));
                }).catch(error => {
                    console.log(error);
                    PNotify.alert('Не удалось получить список пользователей');
                }).finally(() => { this.isLoadingAgentsFilter = false; })
            },

            async searchCuratorsFilter() {
                // Данные загружаются или уже получены
                if (this.isLoadingCuratorsFilter || this.curatorsList.length > 0) {
                    return;
                }

                this.isLoadingCuratorsFilter = true;

                axios.get('/curators-list-local-get').then(response => {
                    this.curatorsList = JSON.parse(window.atob(response.data));
                }).catch(error => {
                    console.log(error);
                    PNotify.alert('Не удалось получить список кураторов');
                }).finally(() => { this.isLoadingCuratorsFilter = false; })
            },
            async downloadAgentsExport() {
                if (this.loading) {
                    return;
                }
                const data = {
                    s: this.pagination.sortBy,
                    desc: this.pagination.descending,
                    p: this.pagination.page,
                    i: -1,
                    f: JSON.stringify(this.filters),
                    prolong: this.isProlong
                };
                this.loading = true;
                await axios.post('agents/export', data, {
                    responseType: 'blob'
                }).then(response => {
                    console.log(response)
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'agents-export.xlsx'); // Название файла, который будет сохранен
                    document.body.appendChild(link);
                    link.click();
                    link.parentNode.removeChild(link);
                })
                    .catch(error => {
                        console.log(error);
                        PNotify.error('Возникли ошибки при формировании файла');
                        this.loading = false;
                    });
                this.loading = false;
            }

        },
    }
</script>
<style>
    tr.not-read{
        background: #eee;
    }
</style>

<style scoped>
    .submit-button {
        color: #ffffff !important;
        line-height: 1.45 !important;
        font-weight: 700 !important;
        font-size: 18px !important;
        text-transform: none !important;
        box-shadow: none !important;

        height: 56px;
        background-color: #00ba57 !important;;
        text-align: center;
        vertical-align: middle;
        padding: 0 !important;
        margin: 0 5px;

        border-width: 1px;
        border-radius: 100px;
        border-color: transparent;
        border-style: solid;
    }

    .submit-button >>> .v-btn__content {
        white-space: pre-wrap;
        padding: 16px 40px 0;
        line-height: 1.1;
    }

    .preview-button {
        color: #ffffff !important;
        line-height: 1.45 !important;
        font-weight: 700 !important;
        font-size: 19px !important;
        text-transform: none !important;
        box-shadow: none !important;

        height: 70px;
        width: 90%;
        background-color: #00ba57 !important;
        text-align: center;
        padding: 0 30px !important;

        border-width: 1px;
        border-radius: 100px;
        border-color: transparent;
        border-style: solid;
    }

    /deep/ h1 {
        font-size: 65px;
        font-family: 'SFUIDisplay', 'Arial', 'sans-serif';
        line-height: 1;
        font-weight: 700;
        color: #000000;
    }

    @media (max-width: 960px) {
        /deep/ h1 {
            font-size: 54px;
        }
    }

    @media (max-width: 960px) {
        /deep/ h1 {
            font-size: 38px;
        }
    }

    /deep/ h2, h3 {
        font-family: 'SFProBold';
    }

    /deep/ h2 {
        font-size: 28px;
    }

    /deep/ h3 {
        font-size: 20px;
    }

    /deep/ .v-tabs__item {
        justify-content: left;
        text-transform: none;
        font-size: 16px;
        font-weight: 500;
    }

    /deep/ .v-tabs__item--active {
        font-weight: 700;
    }

    .agent-actions a {
        color: black;
        margin-right: 40px;
    }

    .agent-actions a img {
        margin-right: 5px;
        width: 21px;
        height: 21px;
        vertical-align: -5px;
    }

    .agent-actions a.disabled {
        color: grey;
    }

    .agent-actions a.disabled img {
        color: grey;
        -webkit-filter: grayscale(100%);
        filter: grayscale(100%);
    }

    /deep/ table.v-table tbody td,
    /deep/ table.v-table thead th {
        font-size: 14px;
        white-space: nowrap;
    }

    /deep/ table.v-table thead td:not(:nth-child(1)),
    /deep/ table.v-table tbody td:not(:nth-child(1)),
    /deep/ table.v-table thead th:not(:nth-child(1)),
    /deep/ table.v-table tbody th:not(:nth-child(1)),
    /deep/ table.v-table thead td:first-child,
    /deep/ table.v-table tbody td:first-child,
    /deep/ table.v-table thead th:first-child,
    /deep/ table.v-table tbody th:first-child {
        padding: 0 5px;
    }

    .link {
        font-size: 14px;
        font-weight: bold;
        text-decoration: unset !important;
        color: #FF5252 !important;
    }

    /deep/ .filters .v-input__slot,
    /deep/ .filters .v-input__control,
    /deep/ .filters .v-text-field {
        padding-top: 0 !important;
        padding-bottom: 0 !important;
        margin-top: 0 !important;
        margin-bottom: 0 !important;
    }

    .seg-template-btn {
        background-color: #00ba57 !important;
        color: #fff !important;
        margin-bottom: 20px;
        height: 56px;
        border-radius: 30px;
        font: 18px 'SFPro', sans-serif;
        font-weight: 700!important;
    }

    .wrappable {
        word-wrap: break-word;
        white-space: normal;
    }
</style>

<style scoped lang="scss">
.v-menu__content {
    border-radius: 14px;
    border: 1px solid #e9eceb;
}

.breadcrumb-new {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 36px;
    font-size: 16px;
    color: #6b7a72;
}

.breadcrumb-new a {
    color: #00BA57;
    text-decoration: none;
    font-weight: 500;
    transition: opacity .2s;
}
.breadcrumb-new a:hover { opacity: .7; }
.breadcrumb-new span { color: #c8d4cc; }

@keyframes fadeUp {
    from { opacity: 0; transform: translateY(14px); }
    to   { opacity: 1; transform: translateY(0); }
}
.breadcrumb-new { animation: fadeUp .4s ease both; }

.top-row {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    gap: 24px;
    flex-wrap: wrap;
    margin-bottom: 80px;

    @media (max-width: 960px) {
        flex-direction: column;
        align-items: unset;
    }
}

.page-title {
    span {
        color: #00BA57;
    }

    animation: fadeUp .6s ease both;
}

.action-buttons {
    display: flex;
    flex-direction: row;
    gap: 20px;

    animation: fadeUp .6s ease both;

    button {
        @media (max-width: 480px) {
            width: 100%;
            flex-shrink: 1;
        }
    }

    @media (max-width: 480px) {
        flex-direction: column;
    }
}

.control-bar {
    display: flex;
    flex-direction: row;
    gap: 12px;
    align-items: stretch;
    animation: fadeUp 1s ease both;

    @media (max-width: 960px) {
        grid-template-columns: unset;
        grid-template-rows: 1fr auto;
    }
}

.search-cluster {
    display: flex;
    gap: 10px;
    background: #ffffff;
    border: 1.5px solid #e2e8e4;
    border-radius: 16px;
    padding: 6px 6px 6px 20px;
    align-items: center;
    justify-content: center;
    width: 100%;
    transition: border-color .2s, box-shadow .2s;
    box-shadow: 0 2px 12px rgba(0,0,0,.04);
}
.search-cluster:focus-within {
    border-color: #00BA57;
    box-shadow: 0 0 0 4px rgba(29, 185, 84, 0.18);
}

/* text search */
.text-search {
    flex: 1;
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;
}
.text-search svg { color: #b0bfb6; flex-shrink: 0; }
.text-search input {
    border: none;
    outline: none;
    width: 100%;
    font-family: 'SFPro', 'Arial', 'sans-serif';
    font-size: 15px;
    color: #111814;
    background: transparent;
}
.text-search input::placeholder { color: #b0bfb6; }

/* buttons cluster */
.btn-cluster {
    display: flex;
    gap: 8px;
    align-items: center;
}

.btn {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    font-family: 'SFPro', 'Arial', 'sans-serif';
    font-weight: 400;
    font-size: 15px;
    border: none;
    cursor: pointer;
    border-radius: 28px;
    padding: 0 22px;
    height: 52px;
    white-space: nowrap;
    transition: transform .15s, box-shadow .15s, background .15s;
}
.btn:active { transform: scale(.97); }

.btn-primary {
    background: #00BA57;
    color: #fff;
    box-shadow: 0 4px 16px rgba(29,185,84,.3);
}
.btn-primary:hover {
    background: #01af52;
    box-shadow: 0 6px 24px rgba(29,185,84,.45);
}

.btn-outline {
    background: #ffffff;
    color: #111814;
    border: 1.5px solid #e2e8e4;
    box-shadow: 0 2px 8px rgba(0,0,0,.04);
}
.btn-outline:hover {
    border-color: #00BA57;
    color: #00BA57;
    background: #f0faf4;
}

.btn-search-width {
    width: 165px;
}

.btn-report-wrapper {
    display: flex;
    flex-direction: row;
    align-items: center;
    padding-top: 4px !important;
    @media (max-width: 960px) {
        justify-content: unset;
    }
}

.btn-report-width {
    max-width: 300px;
    width: 100%;
}

.btn-set-template {
    margin-bottom: 20px;
}

.spinner {
    display: inline-block;
    width: 16px;
    height: 16px;
    border: 2px solid rgba(255,255,255,0.3);
    border-radius: 50%;
    border-top-color: white;
    animation: spin 0.6s linear infinite;
    margin-right: 6px;
    vertical-align: middle;
}

@keyframes spin {
    to {
        transform: rotate(360deg);
    }
}

.filters-block {
    &__header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 24px;
        cursor: pointer;
        transition: all 0.4s ease-in-out;

        &:hover {
            background-color: #e7e7e7;
        }

        .arrow-up-down {
            color: #000000;
            font-size: 20px;
            transition: transform .4s ease-in-out;

            user-select: none;
        }

        .rotate {
            transform: rotate(-180deg);
        }
    }

    &__body {
        padding: 14px;

        .filters-actions {
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            padding: 0 10px;
        }
    }

    .v-expansion-panel {
        box-shadow: unset;
        margin: 0;

        &__body {
            p {
                margin-bottom: 0;
            }
        }
    }
}

.report-layout {
    animation: fadeUp 1.2s ease both;
}

.policy-list-table {
    animation: fadeUp 1.2s ease both;
    background: #ffffff;
    border-radius: 14px;
    border: 1px solid #e9eceb;
    box-shadow: 0 6px 20px rgba(0,0,0,0.05);
    overflow: hidden;

    .flex {
        padding: 10px;
    }

    &__header {
        padding: 14px;
        display: flex;

        @media (max-width: 850px) {
            overflow-x: scroll;
        }

        .download-excel-button {
            margin-left: auto;
        }
    }

    &__body {
        padding: 14px;
    }
}

.table-row {
    position: relative;
}

.table-actions {
    position: sticky;
    right: 0;
    z-index: 5;

    /*min-width: 60px;
    padding: 0 12px;*/

    background:
        linear-gradient(to left, #fff 80%, rgba(255,255,255,0));

    /*box-shadow: inset 6px 0 8px rgba(0,0,0,0.08);*/
}
</style>



// WEBPACK FOOTER //
// resources/js/components/b2b/AgentsList.vue